import { useEffect, useState } from "react";
import { Flex, Text } from "@radix-ui/themes";
import { DevicePhoneMobileIcon, ServerStackIcon, GlobeAltIcon, MapPinIcon, UserGroupIcon } from "@heroicons/react/24/outline";
import { MenuItem } from "components";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

const getMenuStateFromPath = (path) => {
  if (path.includes("/guest-wifi/connections")) return "connections";
  if (path.includes("/guest-wifi/networks")) return "networks";
  if (path.includes("/guest-wifi/locations")) return "locations";
  if (path.includes("/guest-wifi/contacts")) return "contacts";
  return "captive-portal";
};

export function WifiLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const [menuSelection, setMenuSelection] = useState(
    getMenuStateFromPath(location.pathname)
  );

  useEffect(() => {
    setMenuSelection(getMenuStateFromPath(location.pathname));
  }, [location.pathname]);

  const handleMenuSelection = (flag) => {
    setMenuSelection(flag);
    navigate(flag);
  };

  return (
    <Flex
      direction="column"
      gap="5"
      height="100%"
      style={{
        alignSelf: "stretch",
        alignItems: "flex-start",
        flex: "1 1 0",
        minHeight: 0,
        overflow: "hidden",
      }}
    >
      {/* Main content */}
      <Flex className="main-content-container" gap="8" px="5" py="5"
        style={{ alignSelf: "stretch", flex: "1 1 0", alignItems: "flex-start", minHeight: 0, overflow: "hidden" }}>
        {/* Sidebar menu */}
        <Flex className="main-content-sidebar-menu" width="144px" direction="column" gap="1" height="100%" 
          style={{ alignItems: "flex-start", minHeight: 0 }}>
          <MenuItem
            flag="captive-portal"
            state={menuSelection}
            onClick={handleMenuSelection}
            text="Captive portal"
            tooltip="Manage captive portal designs"
            icon={<DevicePhoneMobileIcon height={16} width={16} />}
          />
          <MenuItem
            flag="networks"
            state={menuSelection}
            onClick={handleMenuSelection}
            text="Networks"
            tooltip="Manage guest, work and staff networks"
            icon={<ServerStackIcon height={16} width={16} />}
          />
          <MenuItem
            flag="locations"
            state={menuSelection}
            onClick={handleMenuSelection}
            text="Locations"
            tooltip="View WiFi status across locations"
            icon={<MapPinIcon height={16} width={16} />}
          />
          <MenuItem
            flag="contacts"
            state={menuSelection}
            onClick={handleMenuSelection}
            text="Contacts"
            tooltip="View guest WiFi contacts"
            icon={<UserGroupIcon height={16} width={16} />}
          />
          <MenuItem
            flag="connections"
            state={menuSelection}
            onClick={handleMenuSelection}
            text="Connections"
            tooltip="View guest WiFi connection analytics"
            icon={<GlobeAltIcon height={16} width={16} />}
          />
        </Flex>
        
        {/* Main content area */}
        <Flex style={{ alignSelf: "stretch", flex: "1 0 0", alignItems: "flex-start", height: "100%", minHeight: 0, minWidth: 0 }}>
          <Outlet context={{ embeddedInGuestWifi: true }} />
        </Flex>
      </Flex>
    </Flex>
  );
}
